/* floating-add-to-cart.js — v2
   pulsante fluttuante che fa scroll di ancora + offset + header
-----------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  /* ► 1. Elementi base */
  const anchor = document.querySelector('form[id^="product-form-"]');  // form prodotto
  const floatBtn = document.getElementById('FloatingAddToCart');
  if (!anchor || !floatBtn) return;

  /* ► 2. Parametri FACILMENTE REGOLABILI */
  const EXTRA_SCROLL  = 650;            // quanto spazio sopra il form (px)
  const SHOW_WHEN     = 40;             // margine prima di mostrare il pulsante (px)

  /* ► 3. Altezza header (se è sticky) */
  const header = document.querySelector('header, .shopify-section-header');
  const HEADER_H = header && getComputedStyle(header).position === 'fixed'
                   ? header.offsetHeight
                   : 0;

  /* ► 4. Mostra/Nasconde */
  const toggle = () => {
    const rect = anchor.getBoundingClientRect();
    (rect.bottom < -SHOW_WHEN)
      ? floatBtn.classList.add('show')
      : floatBtn.classList.remove('show');
  };
  toggle();
  window.addEventListener('scroll', toggle);

  /* ► 5. Click = scroll dolce */
  floatBtn.addEventListener('click', () => {
    const y = anchor.getBoundingClientRect().top + window.pageYOffset
            - HEADER_H - EXTRA_SCROLL;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
});

